export default function hourOfDay(value, displayMode = 'full') {
  if (value == null) {
    return '';
  }

  if (Number.isNaN(value)) {
    console.log('HourOfDayPipe called with non-numeric input: ', value);
    return '';
  }

  if (value >= 24) {
    // eslint-disable-next-line no-param-reassign
    value -= 24;
  }

  const isAm = value < 12;

  // eslint-disable-next-line no-nested-ternary
  const suffix = displayMode === 'full'
    ? (isAm ? 'am' : 'pm') : '';

  if (value === 0) {
    return `12${suffix}`;
  }

  let hours = Math.floor(value);
  const minutes = Math.floor((value - hours) * 60);

  if (!isAm) {
    if (hours > 12) {
      hours -= 12;
    }
  }

  const minutesFormatted = minutes ? `:${minutes.toString().padStart(2, '0')}` : '';

  return `${hours}${minutesFormatted}${suffix}`;
}
